module.exports = __webpack_public_path__ + "static/media/live-stream.f08c3b1c.svg";